import '@babel/polyfill';
import svg4everybody from 'svg4everybody';
import $ from 'jquery';
import gsap from 'gsap';
import objectFitImages from 'object-fit-images';

svg4everybody();
objectFitImages();

window.$ = $;
window.jQuery = $;
window.gsap = gsap;
window.objectFillImages = objectFitImages;

require('ninelines-ua-parser');
